import React, { useState, useMemo, useEffect } from "react";
import { MdEdit, MdDelete } from "react-icons/md";
import { PropertiesStore } from "../../Store/PagesStore/properties";
import PropertyForm from "../Popups/propertiesPopup";
import Dropdown from "../Common/Dropdown/main";
import SearchBar from "../Common/SearchBar/main";
import { TriggerStore } from "../../Store";
import { Popup } from "../Common/Popup/main";
import DeletePopup from "../Popups/deletePopup";
import { useProperties } from "../../hook/useProperties";
import { Property } from "../../hook/types/property";
import PropertyList from "./card";
import PopupHistory from "./historyPopub";
import { FaSpinner } from "react-icons/fa";

import { useQueryClient } from "@tanstack/react-query";

const EditAndDeleteButton: React.FC<{
  onEdit: () => void;
  onDelete: () => void;
}> = ({ onEdit, onDelete }) => {
  return (
    <div className="flex space-x-2">
      <button className="btn btn-secondary" onClick={onEdit}>
        <MdEdit className="h-5 w-5 hover:text-primary" />
      </button>
      <button className="btn btn-danger" onClick={onDelete}>
        <MdDelete className="h-5 w-5 hover:text-red-500" />
      </button>
    </div>
  );
};

const PropertiesCard: React.FC = () => {
  const {
    addProperty,
    Property,
    deleteProperty,
    getPropertyById,
    updateProperty,
  queryClient
  } = useProperties();
  const [isActive, setIsActive] = useState<boolean | null>(true);
   const [isDelete, setIsDelete] = useState<boolean>(false);

  const { sidebarAction, sidebartrigger } = TriggerStore((state) => state);
  const { Properties, editProperty } = PropertiesStore((state) => state);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [openPopup, setOpenPopup] = useState(false);
  const [DeletPopup, setDeletPopup] = useState(false);
  const [edit, setEdit] = useState(true);
  const [activeId, setActiveId] = useState("");
  const [addPropertyStatus, setAddProperty] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProperty, setSelectedProperty] = useState<Property >(
    {
      isActive:false,
      noOfRooms:0,
      propertyAddress:"",
      propertyDepositAmount:0,
      propertyImageUrl:"",
      propertyName:"",
      propertyRent:0,
      propertyType:"",
      propertySize:0,
      propertyStatus:"UNOCCUPIED",
      tenantContact:123456789,
      tenantName:"",
    }
  );
  const [isHistoryPopup, setIsHistoryPopupOpen] = useState(false);

 const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
 

  const Propertiess = Property({ active: isActive,delete: isDelete, page: currentPage, size: itemsPerPage });

  const ActiveColumns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "propertyId", title: "Property ID", type: "text" },
    { key: "propertyAddress", title: "Property Address", type: "text" },
    { key: "propertyType", title: "Property Type", type: "text" },
    { key: "propertyStatus", title: "Property Status", type: "text" },
    { key: "propertyDepositAmount", title: "Deposit Amount", type: "number" },
    { key: "propertyRent", title: "Rent Amount", type: "number" },
    { key: "propertySize", title: "Size (in Sq. ft.)", type: "number" },
    { key: "noOfRooms", title: "No. of Rooms", type: "number" },
    { key: "actions", title: "Actions", type: "component" },
  ];
  const UnActiveColumns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "propertyId", title: "Property ID", type: "text" },
    { key: "propertyAddress", title: "Property Address", type: "text" },
    { key: "propertyType", title: "Property Type", type: "text" },
    { key: "propertyStatus", title: "Property Status", type: "text" },
    { key: "propertyDepositAmount", title: "Deposit Amount", type: "number" },
    { key: "propertyRent", title: "Rent Amount", type: "number" },
    { key: "propertySize", title: "Size (in Sq. ft.)", type: "number" },
    { key: "noOfRooms", title: "No. of Rooms", type: "number" },
  ];


const [filterType, setFilterType] = useState<"Active" | "Inactive" | "Deleted">("Active");


useEffect(() => {

  if (filterType === "Active") {
    setIsActive(true);
    setIsDelete(false);
  } else if (filterType === "Inactive") {
    setIsActive(false);
    setIsDelete(false);
  } else if (filterType === "Deleted") {
    setIsActive(null);
    setIsDelete(true);
  }
}, [filterType]);


  useEffect(() => {
    Propertiess.refetch();
  }, [isActive,isDelete, currentPage, itemsPerPage]);
  const handleEdit = async (property: Property, Id: string) => {
    setAddProperty(false)
  
    setSelectedProperty(
      property
    );
    setActiveId(Id);
    setOpenPopup(true);
  };
 


  const handleDelete = async () => {
    await deleteProperty.mutateAsync(activeId); // deleteProperty(activeId);
    setDeletPopup(false);
  };



  const handleSubmit = async (formData: Property) => {
    try {
      if (addPropertyStatus) {
        await addProperty.mutateAsync({
          isActive: formData.isActive,
          propertyName: formData.propertyName,
          propertyAddress: formData.propertyAddress,
          propertyType: formData.propertyType,
          propertyRent: formData.propertyRent,
          propertyStatus: formData.propertyStatus,
          noOfRooms: formData.noOfRooms,
          propertyDepositAmount: formData.propertyDepositAmount,
          propertySize: formData.propertySize,
          document: formData.propertyImageUrl as any,
        });
      } else {
        await updateProperty.mutateAsync(
          { propertyId: activeId, updatedProperty: formData },
          {
            onSuccess: () => {
              // Invalidate the query to refetch the data
              queryClient.invalidateQueries({ queryKey: ["properties"] });
            },
          }
        );
      }
  
      setOpenPopup(false);
      setAddProperty(false);
    } catch (error) {
      console.error("Error occurred during property mutation:", error);
    }
  };

  const handleCancel = () => {
    setOpenPopup(false);
  };
  const { commercialProperties, residentialProperties } = useMemo(() => {
    if (Propertiess.isSuccess && Propertiess.data?.data) {
      const commercial = Propertiess.data.data.COMMERCIAL.filter((property) =>
        property.propertyName.toLowerCase().includes(searchQuery.toLowerCase())
      );
  
      const residential = Propertiess.data.data.RESIDENTIAL.filter((property) =>
        property.propertyName.toLowerCase().includes(searchQuery.toLowerCase())
      );
  
      return {
        commercialProperties: commercial,
        residentialProperties: residential,
      };
    }
  
    return {
      commercialProperties: [],
      residentialProperties: [],
    };
  }, [Propertiess.data, searchQuery]);
  

 const indexOfLastItem = currentPage * itemsPerPage;
 const indexOfFirstItem = indexOfLastItem - itemsPerPage;

 

  return (
    <div className="h-screen flex w-full flex-col">
      <header className="sticky top-0  backdrop-blur-md bg-white shadow z-10">
        <h1 className="text-2xl text-start font-bold px-5 py-2">
        Properties
        </h1>
        <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
          <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
           
            <div onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
              <Dropdown
                options={["Active", "Inactive", "Deleted"]}
                className="w-full sm:w-60"
                className2="py-3 text-sm"
                
                 onSelect={(e) => {
      setFilterType(e as "Active" | "Inactive" | "Deleted");
      setStatusDropdownOpen(false);
    }}
    activeOption={filterType}
                isOpen={statusDropdownOpen}
                setIsOpen={setStatusDropdownOpen}
                closeOtherDropdown={() => {}}
              />
            </div>
            {/* <div className="w-full sm:w-auto">
              <SearchBar onClear={() =>{
                setSearchQuery("")
              }} onSearch={(query) => setSearchQuery(query)} />
            </div> */}
          <div className="w-full sm:w-auto">
  <SearchBar
    suggestionInputEnable={{
      setActiveValue: (value: string) => {
        setSearchQuery(value);
      },
      activeValue: searchQuery,
      enable: true,
      loading: Propertiess.isLoading,
      onSuggestionSelect: (index: number) => {
        // Get all property names from both commercial and residential
        const allPropertyNames = [
          ...commercialProperties.map((property: any) => property.propertyName),
          ...residentialProperties.map((property: any) => property.propertyName)
        ];
        if (allPropertyNames[index]) {
          setSearchQuery(allPropertyNames[index]);
        }
      },
      suggestions: [
        ...commercialProperties.map((property: any) => property.propertyName),
        ...residentialProperties.map((property: any) => property.propertyName)
      ],
    }}
    onClear={() => {
      setSearchQuery("");
    }}
    onSearch={(query) => setSearchQuery(query)}
  />
</div>
            <button
              className="bg-primary justify-center gap-1 text-white flex hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
              onClick={() => {
                setSelectedProperty( {
                  isActive:false,
                  noOfRooms:0,
                  propertyAddress:"",
                  propertyDepositAmount:0,
                  propertyImageUrl:"",
                  propertyName:"",
                  propertyRent:0,
                  propertyType:"",
                  propertySize:0,
                 // propertyStatus:"",
                  propertyStatus:"UNOCCUPIED",
                  tenantContact:123456789,
                  tenantName:""
            
                })
                setAddProperty(true);
                setOpenPopup(true);
              }}
            >
              Add{" "}
              <span className="lg:hidden sm:block md:block   xl:block">
                New
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Scrollable Table */}
     
      {Propertiess.isLoading?  <div className="h-full w-full justify-center flex items-center">
        <p className="flex gap-1 justify-center   text-black items-center">
          <FaSpinner className="animate-spin mr-2" /> Loading...
        </p>
      </div>: <div>
     <div className="min-w-full flex gap-2 flex-col  p-4 ">
          <p className="text-base font-semibold py-1  w-full border-b border-gray-300">Commercial Properties</p>
          { commercialProperties.length < 0 ? (
            <p>no data</p>
          ) : (
          
            <PropertyList
            loading={Propertiess.isLoading}
            onOpenPopup={() =>setIsHistoryPopupOpen(true)}
             properties={commercialProperties} handleEdit={(item:any,id:any) => {
              handleEdit(item, id);
            } } handleDelete={() =>{
              setDeletPopup(true)
            }} setActiveId={(value:any) =>{
              setActiveId(value)
            } } setEdit={(value:boolean) =>{
              setEdit(value)
            }}
             />
          )}
        </div>
      <div className="min-w-full flex flex-col gap-2  p-4 ">
      <p className="text-base font-semibold  py-1  w-full border-b border-gray-300">Residential Properties</p>
          { commercialProperties.length < 0 ? (
            <p>no data</p>
          ) : (
         
            <PropertyList
            loading={Propertiess.isLoading}
            onOpenPopup={() =>setIsHistoryPopupOpen(true)}
             properties={residentialProperties} handleEdit={(item:any,id:any) => {
              handleEdit(item, id);
            } } handleDelete={() =>{
              setDeletPopup(true)
            }} setActiveId={(value:any) =>{
              setActiveId(value)
            } } setEdit={(value:boolean) =>{
              setEdit(value)
            }}
             />
          )}
        </div>
     </div>}

     
      {openPopup && (
        <Popup
          className="lg:top-5"
          closeButton={true}
          children={
            <PropertyForm
              isLoading={updateProperty.isPending || addProperty.isPending}
              initialData={selectedProperty as any}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isOpen={openPopup}
              id={edit ? activeId : ""}
            />
          }
          onClose={() => setOpenPopup(false)}
        />
      )}
      {DeletPopup && (
        <Popup
          children={
            <DeletePopup
              isLoading={deleteProperty.isPending}
              isOpen={DeletPopup}
              onClose={() => setDeletPopup(false)}
              onDelete={handleDelete}
            />
          }
          onClose={() => setDeletPopup(false)}
        />
      )}

      <PopupHistory id={activeId}  isOpen={isHistoryPopup} onClose={() =>{
        setIsHistoryPopupOpen(false)
      } }/>
     
    </div>
  );
};

export default PropertiesCard;
